import dayjs from 'dayjs';
import strings from '../../Globalization';
import consts from '../../consts';

export const getPrintData = (cycleTape, options = {}) => {
	const cycleTapeStr = cycleTape || '';
	const { isUltrasonic } = options;
	if (isUltrasonic) {
		return cycleTapeStr
			.replace('<PrinterLines />', '')
			.replace(/<PrinterLine>/g, '')
			.replace(/<PrinterLine \/\>/g, '')
			.replace(/<\/\PrinterLine>/g, '<br/>')
			.replace(/PrinterLines/g, 'p')
			.replace(/ /g, '&nbsp;');
	} else {
		return cycleTapeStr
			.replace('<PrinterLines />', '')
			.replace(/<PrinterLine>/g, '')
			.replace(/<PrinterLine \/\>/g, '<br/>')
			.replace(/<\/\PrinterLine>/g, '<br/>')
			.replace(/PrinterLines/g, 'p')
			.replace(/ /g, '&nbsp;');
	}
};



export const evalCriticalParameters = ({ data }) => {

	const criticalParameters = data.CriticalParameters.map((entry) => {
		const actualDataProperty1 = entry.ActualDataProperty1 ?? '';
		const actualDataProperty2 = entry.ActualDataProperty2 ?? '';
		const metricDataProperty1 = (entry.MetricDataProperty1 ?? '');
		const metricDataProperty2 = (entry.MetricDataProperty2 ?? '');
		const actualConnector = actualDataProperty1 !== '' && actualDataProperty2 !== '' ? ' - ' : '';
		const metricConnector = metricDataProperty1 !== '' && metricDataProperty2 !== '' ? ' - ' : '';
		return {
			...entry,
			Actual: (entry.Actual ?? `${actualDataProperty1}${actualConnector}${actualDataProperty2}`),
			Metric: entry.Metric ?? `${metricDataProperty1}${metricConnector}${metricDataProperty2}`,
			RowSpan: entry.RowSpan ?? 0,
			UnitHeader: entry.UnitHeader,
			UnitSubHeader: entry.UnitSubHeader,
			isVisible: true
		};
	});
	return criticalParameters;
};

export const getPrintDetailsParams = ({ data, dateTimeFormat }) => {
	let rows = data.TopSection;
	const isEnspire = data.EquipmentFamilyId === consts.EquipmentFamilyType.ENSPIRE;
	const topSection = rows
		.filter(({ name }) => name !== 'equipment')
		.reduce((acc, curr) => {
			const entries = curr.entries
			if (curr.name === 'endoEnspireTop' || curr.name === 'endoScopeTop') {
				entries.unshift({
					HeaderLabel: strings.EndoScopeTop,
					Value: '',
					Index: 3
				});
			} else if (curr.name === 'endoEnspireBottom' || curr.name === 'endoScopeBottom') {
				entries.unshift({
					HeaderLabel: strings.EndoScopeBottom,
					Value: '',
					Index: 3
				});
			}
			return acc.concat(entries);
		}, [])
		.map((item) => ({
			...item,
			Label: strings[item.HeaderLabel] || item.HeaderLabel,
			Value: (item.value || item.Value),
			Image: item.Value || '',
			ImageColor: item.IsCustomRendering ? (item.Value.indexOf('times') > -1 ? 'red' : '#1ab394') : '',
			Index: item.Index >= 0 ? item.Index : -1
		}));
	const printData = data.CycleTape || data.PrinterLines || '';
	const pageInfo = [
		{ Property: 'ReportTitle', Value: strings.CycleLogs || '', LangString: strings.CycleLogs },
		{ Property: 'EquipmentName', Value: data.EquipmentName || '', LangString: strings.EquipmentName },
		{ Property: 'EquipmentType', Value: data.EquipmentTypeName || '', LangString: strings.EquipmentType },
		{ Property: 'SerialNumber', Value: data.SerialNumber || '', LangString: strings.SerialNumber },
		{ Property: 'ModelName', Value: data.ModelName || '', LangString: strings.ModalName },
		{ Property: 'Location', Value: data.LocationName || '', LangString: strings.LocationName },
		{ Property: 'CycleCount', Value: data.CycleCount || '', LangString: strings.CycleCount },
		{
			Property: 'CycleDate',
			Value: dayjs(data.CycleStart).format(dateTimeFormat.datetime) || '',
			LangString: strings.CycleDateTime
		},
		{ Property: 'Parameter', LangString: strings.Parameter },
		{ Property: 'Metric', LangString: strings.Metric },
		{ Property: 'Actual', LangString: strings.Actual },
		{ Property: 'CriticalParamenterTitle', LangString: strings.CriticalParamenterTitle }
	];
	const criticalParameters = evalCriticalParameters({
		data,
		dateTimeFormat
	}).map((obj) => ({
		...obj,
		SubHeaderLabel: obj.SubHeaderLabel ?? '',
		Index: obj.Index ?? 0,
		UnitHeader: obj.UnitHeader ?? '',
		UnitSubHeader: obj.UnitSubHeader ?? '',
		ColSpan: obj.ColSpan ?? 0,
		RowSpan: obj.RowSpan ?? 0,
		Metric: obj.Metric ?? '',
		Actual: obj.Actual ?? '',
		CriticalParameterIcon: obj.CriticalParameterIcon ?? '',
		Control: obj.Control ?? '',
		Independent: obj.Independent ?? '',
		TabHeader: obj.TabHeader ?? false
	}));



	const requestParameters = [
		{ Name: 'action', Value: 'otherAction' },
		{ Name: 'otherAction', Value: 'printReport' },
		{ Name: 'cycleCount', Value: data.CycleCount },
		{ Name: 'imageUrl', Value: data.CycleImageUrl },
		{ Name: 'cycleName', Value: data.CycleName },
		{ Name: 'cycleTape', Value: printData },
		{ Name: 'topSection', Value: JSON.stringify(topSection) },
		{ Name: 'criticalParameters', Value: JSON.stringify(criticalParameters) },
		{ Name: 'pageInfo', Value: JSON.stringify(pageInfo) },
		{ Name: 'isWasherOrLCS', Value: true },
		{ Name: 'isEnspire', Value: isEnspire }
	];

	return requestParameters;
};